import { render } from "./ProducerLateDeliveryModal.vue?vue&type=template&id=767d8ff1"
import script from "./ProducerLateDeliveryModal.vue?vue&type=script&lang=js"
export * from "./ProducerLateDeliveryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__